import React from 'react'
import { map, isUndefined, pickBy, keys } from 'lodash'
import moment from 'moment'
import { getDateISO, getDateTimeISO } from './date'
import { getOptionLabel } from './input-element'

export const formatDate = (
  value,
  format,
  isScheduledMode,
  payloadMapper,
  elementId
) => {
  const m = moment(Date.parse(value))

  let result = `${m.format(format.value)} `

  if (isScheduledMode) {
    const ruleString = payloadMapper[elementId]
    result += ruleString
  }

  return m.isValid() ? result?.trim() : ''
}

const typeToString = {
  radio: ({ t, value }) => t(value.label),
  toggle: ({ t, value }) => (value ? t('YES') : t('NOT')),
  select: ({ t, value }) => getOptionLabel(t, value.label) || value.toString(),
  multiselect: ({ value }) => map(value, 'label').join(', '),
  checkbox: ({ value }) => keys(pickBy(value, (el) => el)).join(', '),
  datetime: ({ value, formattedDate, formatOptions: { dateTimeFormat } }) =>
    formattedDate
      ? formatDate(value, dateTimeFormat)
      : !isNaN(Date.parse(value))
      ? getDateTimeISO(value.toString(), 'datetime')
      : '',
  date: ({
    value,
    defaultValue,
    deltaDefault,
    formattedDate,
    formatOptions: { dateFormat },
    isScheduledMode,
    payloadMapper,
    elementId
  }) => {
    return formattedDate
      ? formatDate(value, dateFormat, isScheduledMode, payloadMapper, elementId)
      : !isNaN(Date.parse(value))
      ? getDateISO(value.toString(), isScheduledMode, payloadMapper)
      : ''
  }
}

export const getDataString = ({
  t,
  type,
  value,
  elementId,
  recapElement,
  formatOptions,
  summary = false,
  formattedDate = false,
  defaultValue,
  deltaDefault,
  isScheduledMode,
  payloadMapper
}) => {
  if (type === 'custom' && !summary && recapElement) {
    const Element = recapElement

    return (
      <Element
        id={elementId}
        value={value}
        formatOptions={formatOptions}
        formattedDate={formattedDate}
      />
    )
  }

  const stringify = typeToString[type]

  if (isUndefined(stringify)) {
    return value
  }
  return stringify({
    t,
    value,
    formatOptions,
    formattedDate,
    defaultValue,
    deltaDefault,
    isScheduledMode,
    payloadMapper,
    elementId
  })
}
